import PropTypes from '@root/vendor/prop-types';
import Responsive from '@root/core/src/utils/responsive';
import renderRichText from '@root/joinroot.com/src/utils/render-rich-text';
import { StyleSheet } from '@root/core/src/utils/styles';

export default function DisclaimerSectionBlock({ content }) {
  return (
    <section
      css={[styles.section, styles.anchorSpacer]}
      data-testid={'disclaimerSectionBlock'}
      id={content.anchor?.anchorSlug}
    >
      {renderRichText(content.disclaimer)}
    </section>
  );
}

DisclaimerSectionBlock.propTypes = {
  content: PropTypes.shape({
    id: PropTypes.string.isRequired,
    anchor: PropTypes.shape({
      id: PropTypes.string,
      anchorSlug: PropTypes.string,
    }),
    disclaimer: PropTypes.shape({
      json: PropTypes.object.isRequired,
    }).isRequired,
  }).isRequired,
};

const styles = StyleSheet.create({
  section: {
    margin: '40px auto',
    padding: '0 20px',
    maxWidth: 460,
    textAlign: 'center',
    'p': {
      fontSize: 14,
    },
    'a': {
      fontSize: 14,
    },
    ...Responsive.md({
      margin: '50px auto',
      padding: 0,
      maxWidth: 700,
    }),
  },
  anchorSpacer: {
    '&:before': {
      display: 'block',
      content: '" "',
      marginTop: -110,
      height: 110,
      visibility: 'hidden',
      pointerEvents: 'none',
    },
  },
});
